export default __webpack_public_path__ + "static/media/light-sun.cbfd619c.svg";